/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import InvoiceAPI from '@/api/InvoiceAPI.js';
import DownloadAPI from '@/api/DownloadAPI.js';
import ReportAPI from '@/api/ReportAPI.js';
import CertificateAPI from '@/api/CertificateAPI.js';
import CertificateTrialAPI from '@/api/CertificateTrialAPI.js';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import i18n from '@/i18n/i18n';

export default {
	loadInvoiceRisk: async function(context, payload) {
		let isShowLoading = payload && payload.isLoading;
		let res = await httpClient.getAsync(
			{
				url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/invoicerisk',
				params: payload
			},
			isShowLoading
		);
		if (res && res.Success) {
			context.commit('updateInvoiceRisk', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	exportInvoiceRisk: async function(context, payload) {
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		let fileName = `Bao_cao_hoa_don_theo_NCC_rui_ro_${dateRange}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportinvoicerisk',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	/**
	 * Xuất khẩu excel báo cáo tổng hợp chi phí
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	exportCostTypeSummary: async function(context, payload) {
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		let fileName = `Bao_cao_tong_hop_chi_phi_${dateRange}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportcosttypesummary',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	exportExcelInvoiceByNorm: async function(context, payload) {
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		let fileName = `Danh_sach_hoa_don_${dateRange}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportinvoicebynorm',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	/**
	 * Xuất khẩu excel báo cáo hóa đơn vượt định mức chi phí
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	exportExceedCost: async function(context, payload) {
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		let fileName = `Bao_cao_hoa_don_vuot_dinh_muc_${dateRange}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportexceedcost',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	/**
	 * Xuất khẩu excel báo cáo loại chi phí và định mức chi phí
	 * @author dqduy 20.02.2025
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	exportTypeAndCost: async function(context, payload) {
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		let fileName = `Bao_cao_loai_chi_phi_va_dinh_muc_${dateRange}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exporttypeandcost',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	exportReportExceedFiveMil: async function(context, payload) {
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		let fileName = `Bao_cao_NCC_tu_5tr_ngay_${dateRange}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportexceedfivemillion',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlobReport(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	getTotalPageInvoiceRisk: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/invoicerisktotal`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalInvoieRiskPage', res.Data);
		}
		return 0;
	},

	loadInvoicesSupplierActive: async function(context, payload) {
		let isShowLoading = payload && payload.isLoading;
		let res = await httpClient.postAsync(
			{
				url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/v2/invoicesupplieractive',
				data: payload
			},
			isShowLoading
		);
		if (res && res.Success) {
			context.commit('updateInvoiceSupplierActive', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	exportInvoiceSupplierActive: async function(context, payload) {
		let fileName = '';
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		switch (payload.ReportSupplierActiveType) {
			case MSEnum.ReportSupplierActiveType.Lastest:
				fileName = `Bao_cao_HD_theo_tinh_trang_hoat_dong_moi_nhat_cua_NCC_${dateRange}.xlsx`;
				break;
			case MSEnum.ReportSupplierActiveType.InvoiceDate:
				fileName = `Bao_cao_HD_theo_tinh_trang_hoat_dong_cua_NCC_tai_ngay_HD_${dateRange}.xlsx`;
				break;
		}

		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportinvoicesupplieractive',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	getTotalInvoiceSupplierActive: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/invoicesupplieractivetotal`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalInvoieSupplierActivePage', res.Data);
		}
		return 0;
	},

	loadReportInvoiceRelated: async function(context, payload) {
		let isShowLoading = payload && payload.isLoading;
		let res = await httpClient.postAsync(
			{ url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/reportinvoicerelated', data: payload },
			isShowLoading
		);
		if (res && res.Success) {
			context.commit('reportinvoicerelated', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	getTotalPageInvoiceRelated: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/invoicerelatedtotal`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalInvoieRelatedPage', res.Data);
		}
		return 0;
	},

	exportInvoiceRelated: async function(context, payload) {
		let fileName = `Bao_cao_HD_thay_the_dieu_chinh_${commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss')}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportinvoicesrelated',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	/**
	 * Tổng số bản ghi báo cáo tổng hợp chi phí
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalPageCostTypeSummary: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/costtypesummarytotal`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalCostTypeSummaryPage', res.Data);
		}
		return 0;
	},

	/**
	 * Load dữ liệu báo cáo tổng hợp chi phí
	 * @author dqduy 16.01.2025
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	loadReportCostTypeSummary: async function(context, payload) {
		let isShowLoading = payload && payload.isLoading;
		let res = await httpClient.postAsync(
			{ url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/costtypesummary', data: payload },
			isShowLoading
		);
		if (res && res.Success) {
			context.commit('updateCostTypeSummary', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	/**
	 * Load dữ liệu báo cáo hóa đơn vượt định mức chi phí
	 * @author dqduy 16.01.2025
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	loadReportExceedCost: async function(context, payload) {
		let isShowLoading = payload && payload.isLoading;
		let res = await httpClient.postAsync(
			{ url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/reportexceedcost', data: payload },
			isShowLoading
		);
		if (res && res.Success) {
			context.commit('updateExceedCost', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	/**
	 * Load dữ liệu báo cáo loại chi phí và định mức chi phí
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 * @author dqduy 20.02.2025
	 */
	loadReportTypeAndCost: async function(context, payload) {
		let isShowLoading = payload && payload.isLoading;
		//Load dữ liệu phân trang từ local
		if (payload && !payload.IsGetTotal && context && context.getters) {
			context.commit('updateTypeAndCost', {
				data: { Data: context.getters.getDataTypeAndCost },
				isGetTotal: payload.IsGetTotal,
				skip: payload.skip,
				take: payload.take
			});
			return context.getters.getDataTypeAndCost;
		} else {
			let res = await httpClient.postAsync(
				{ url: `${ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/reporttypeandcost`, data: payload },
				isShowLoading
			);
			if (res && res.Success) {
				context.commit('updateTypeAndCost', {
					data: res.Data,
					isGetTotal: payload.IsGetTotal,
					skip: payload.skip,
					take: payload.take
				});
				return res.Data;
			}
			return null;
		}
	},

	/**
	 * Tổng số bản ghi báo cáo hóa đơn vượt định mức chi phí
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalPageExceedCost: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/exceedcosttotal`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalExceedCostPage', res.Data);
		}
		return 0;
	},

	/**
	 * Tổng số bản ghi báo cáo loại chi phí và định mức chi phí
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 * @author dqduy 20.02.2025
	 */
	getTotalPageTypeAndCost: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/typeandcosttotal`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalTypeAndCostPage', res.Data);
		}
		return 0;
	},

	getReportInvoiceStick: async function(context, payload) {
		let isShowLoading = payload && payload.isLoading;
		let res = await httpClient.postAsync(
			{ url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/reportinvoicestick', data: payload },
			isShowLoading
		);
		if (res && res.Success) {
			context.commit('updateInvoiceReportStick', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	getTotalPageInvoiceStick: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/invoiceresticktotal`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalInvoiceStickPage', res.Data);
		}
		return 0;
	},

	getInvoiceListForStickPage: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/getinvoicelistforstick`,
				data: payload
			},
			true
		);
		if (res && res.Data) return res.Data;
		return null;
	},

	getTotalinvoiceListForStick: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/gettotalinvoicelistforstick`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalInvoiceListForStick', res.Data);
		}
		return 0;
	},

	exportInvoiceStick: async function(context, payload) {
		let fileName = `Bao_cao_chi_phi_theo_nhan_dan_${commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss')}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportinvoicesstick',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	exportInvoiceListForStick: async function(context, payload) {
		let fileName = `Danh_sach_hoa_don_${commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss')}.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportinvoiceslistforstick',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	/**
	 * Lấy tổng tiền chân trang báo cáo rủi ro (elatic search)
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalAmountPageElasticForRiskAsync: async function(context, payload) {
		//PDDang note: Thực hiện gọi mutiation chung để update loading => (tên mutation: updateLoadingTotalAmountPage, giá trị , root)
		context.commit('updateLoadingTotalAmountPage', true, {
			root: true
		});
		let res = await httpClient.postAsync(
			{ url: `${ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/risktotalamountelastic`, data: payload },
			false
		);
		context.commit('updateLoadingTotalAmountPage', false, {
			root: true
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy tổng tiền chân trang cho hóa đơn rủi ro (dữ liệu mongo)
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalAmountPageForRiskAsync: async function(context, payload) {
		//PDDang note: Thực hiện gọi mutiation chung để update loading => (tên mutation: updateLoadingTotalAmountPage, giá trị , root)
		context.commit('updateLoadingTotalAmountPage', true, {
			root: true
		});
		let res = await httpClient.postAsync(
			{ url: `${ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/risktotalamount`, data: payload },
			false
		);
		context.commit('updateLoadingTotalAmountPage', false, {
			root: true
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy tổng tiền ở chân grid cho báo cáo trạng thái theo ncc (dữ liệu mongo)
	 * @param {*} context
	 * @param {*} payload
	 */
	getTotalAmountStatusSupAsync: async function(context, payload) {
		//PDDang note: Thực hiện gọi mutiation chung để update loading => (tên mutation: updateLoadingTotalAmountPage, giá trị , root)
		context.commit('updateLoadingTotalAmountPage', true, {
			root: true
		});
		let res = await httpClient.postAsync(
			{ url: `${ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/statussuptotalamount`, data: payload },
			false
		);
		context.commit('updateLoadingTotalAmountPage', false, {
			root: true
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy tổng tiền ở chân grid cho báo cáo trạng thái theo ncc (dữ liệu elastic)
	 * @param {*} context
	 * @param {*} payload
	 */
	getTotalAmountStattusSupElasticAsync: async function(context, payload) {
		//PDDang note: Thực hiện gọi mutiation chung để update loading => (tên mutation: updateLoadingTotalAmountPage, giá trị , root)
		context.commit('updateLoadingTotalAmountPage', true, {
			root: true
		});
		let res = await httpClient.postAsync(
			{
				url: `${ReportAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/statussuptotalamountelastic`,
				data: payload
			},
			false
		);
		context.commit('updateLoadingTotalAmountPage', false, {
			root: true
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy danh sách hóa đơn theo loại chi phí và kỳ định mức
	 */
	getListInvoiceByNorm: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/listinvoicebynorm`,
				data: payload
			},
			true
		);
		if (res && res.Data && res.Data.Data.length > 0) {
			context.commit('updateInvoiceByNorm', res.Data);
		} else {
			context.commit('updateInvoiceByNorm', []);
		}
		return null;
	},

	getTotalListInvoiceByNorm: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/totallistinvoicebynorm`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			context.commit('updateInvoiceByNormTotal', res.Data);
		} else {
			context.commit('updateInvoiceByNormTotal', 0);
		}
		return null;
	},

	/**
	 * Lấy tổng tiền chân trang cho hóa đơn vượt ngưỡng 5 triệu
	 * @param {Object} context - Vuex context
	 * @param {Object} payload - Dữ liệu request chứa thông tin lọc hóa đơn
	 * @returns {Object|null} Tổng tiền các loại hoặc null nếu lỗi
	 * @author dqduy 11. 2025
	 */
	getTotalAmountPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync(
			{ url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/totalamountinvexceed`, data: payload },
			false
		);
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy danh sách hóa đơn vượt ngưỡng 5 triệu theo nhà cung cấp và ngày
	 * @param {Object} context - Vuex context
	 * @param {Object} payload - Dữ liệu request chứa SellerTaxCode, InvoiceDate
	 * @returns {Number} Trả về 0
	 * @author dqduy 11.2025
	 */
	getListInvoicesExceed: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/getInvsExceed`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateListInvoicesExceed', res.Data);
		}
		return 0;
	},

	/**
	 * Lấy tổng số hóa đơn vượt ngưỡng 5 triệu theo nhà cung cấp và ngày
	 * @param {Object} context - Vuex context
	 * @param {Object} payload - Dữ liệu request chứa SellerTaxCode, InvoiceDate
	 * @returns {null} Trả về null
	 * @author dqduy 11.2025
	 */
	getTotalListInvoiceExceedFiveMil: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/totalinvoicesexceed`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			context.commit('updateInvoiceExceedTotal', res.Data);
		} else {
			context.commit('updateInvoiceExceedTotal', 0);
		}
		return null;
	}
};
